
 // dropdown progress bar toggle
  function toggleDetails() {
    const dropdown = document.getElementById('points-details');
    const arrowIcon = document.getElementById('arrow-icon');

    dropdown.style.display = dropdown.style.display === 'flex' ? 'none' : 'flex';
    arrowIcon.classList.toggle('rotated');

    dropdown.querySelectorAll('.progress').forEach(bar => {
   //   bar.style.width = dropdown.style.display === 'block' ? bar.dataset.width : '0';
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.progress').forEach(bar => {
      const parentDropdown = bar.closest('#points-details');
      if (!parentDropdown || parentDropdown.style.display !== 'none') {
      //  bar.style.width = bar.dataset.width;
      }
    });
  });

// announcementslider js
  function initCartAnnouncementSlider() {
    var slider = document.querySelector('.cart-announcement-slider');
    if (slider && typeof Flickity !== 'undefined' && !slider.classList.contains('flickity-enabled')) {
      new Flickity(slider, {
        autoPlay: 3000,
        wrapAround: true,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
        pageDots: true
      });
    }
  }

  initCartAnnouncementSlider();

  const observer = new MutationObserver(() => {
    initCartAnnouncementSlider();
    // apps (e.g. Monk) re-render the drawer without calling initializeFlickity
    if (document.querySelector('.cart-collection-slider .cart-favorites-carousel:not(.flickity-enabled)')) {
      initializeFlickity();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

// cart product flickity js
  var favoritesResizeObserver = typeof ResizeObserver !== 'undefined'
    ? new ResizeObserver(function (entries) {
        entries.forEach(function (entry) {
          // re-measure when the carousel becomes visible (e.g. drawer opens after a re-render)
          var flkty = Flickity.data(entry.target);
          if (flkty && entry.contentRect.width > 0) flkty.resize();
        });
      })
    : null;

  function initializeFlickity() {
    var flickityElement = document.querySelector('.cart-collection-slider .cart-favorites-carousel');
    if (!flickityElement || typeof Flickity === 'undefined') return;

    var flkty = Flickity.data(flickityElement);
    if (flkty) {
      flkty.resize();
      return;
    }

								
    new Flickity(flickityElement, {
        cellSelector: '.carousel-cell',
        cellAlign: 'left',
        contain: true,
        groupCells: true,
        imagesLoaded: true,
        lazyLoad: true,
        pageDots: false
    });

    if (favoritesResizeObserver) favoritesResizeObserver.observe(flickityElement);
}
initializeFlickity();